export default {
	mollak_service_charges: {
		en: "Mollak Service Charges",
		ar: "رسوم خدمات ملاك",
	},
	total_payable: {
		en: "Total Payable",
		ar: "إجمالي المستحق",
	},
	current_due: {
		en: "Current Due",
		ar: "المبلغ المستحق الحالي",
	},
	total_outstanding: {
		en: "Total Outstanding",
		ar: "إجمالي المبلغ المستحق",
	},
	total_paid: {
		en: "Total Paid",
		ar: "إجمالي المدفوع",
	},
	invoices: {
		en: "Invoices",
		ar: "أوامر الدفع",
	},
	receipts: {
		en: "Receipts",
		ar: "الإيصالات",
	},
	service_charges_info: {
		en: "Service Charges Information",
		ar: "معلومات رسوم الخدمة",
	},
	total_due: {
		en: "Total Due",
		ar: "إجمالي المستحق",
	},
	total_vat: {
		en: "Total VAT",
		ar: "إجمالي ضريبة القيمة المضافة",
	},
	pay_full_amount: {
		en: "Pay full amount",
		ar: "ادفع كامل المبلغ",
	},
	other_amount: {
		en: "Other amount",
		ar: "أخرى المبلغ",
	},
	general_fund: {
		en: "General Fund",
		ar: "التمويل العام",
	},
	general_fund_rate: {
		en: "General Fund Rate",
		ar: "معدل المال العام",
	},
	reserve_fund: {
		en: "Reserve Fund",
		ar: "التمويل الاحتياطي",
	},
	additional_charges: {
		en: "Additional Charges",
		ar: "رسوم إضافية",
	},
	rate_sq_ft: {
		en: "Rate (AED/Sq.Ft)",
		ar: "المعدل (درهم\\قدم مربع)",
	},
	rate_sq_mt: {
		en: "Rate (AED/Sq.Mt)",
		ar: "المعدل (درهم\\متر مربع)",
	},
	approval_notice: {
		en: "Approval Notice",
		ar: "إشعارموافقة",
	},
	tax_invoice: {
		en: "Tax Invoice",
		ar: "فاتورة ضريبية",
	},
	mollak_reference_number: {
		en: "Invoice Reference #",
		ar: "رقم أمر الدفع",
	},
	statement_of_account: {
		en: "Statement of Account",
		ar: "كشف حساب",
	},
	mollak_payment_success: {
		en: "Your payment has been successful. You will receive the receipt of this payment shortly on your registered email Id.",
		ar: "تمت عملية الدفع بنجاح. سوف تستلم بريدا إلكترونيا بإيصال الدفع على بريدك الالكتروني المسجل خلال دقائق.",
	},
	payment_ref_number: {
		en: "Reference #",
		ar: "الرقم المرجعي",
	},
	property_invoices: {
		en: "Property Invoices",
		ar: "أوامر الدفع",
	},
	total_msc_due_all_props: {
		en: "Total service charges due for all properties",
		ar: "إجمالي المستحقة رسوم الخدمات لجميع العقار",
	},
	last_service_charge_invoice: {
		en: "Last Service Charge Invoice",
		ar: "آخر فاتورة رسوم الخدمة",
	},
	more_info: {
		en: "More Information",
		ar: "مزيد من المعلومات",
	},
	invoice_date: {
		en: "Invoice Date",
		ar: "تاريخ الفاتورة",
	},
	mollak_payment_info: {
		en: "Please note that you will be leaving Land Department website and will be redirected to payment gateway.",
		ar: "يرجى العلم انك ستقوم بمغادرة موقع هيئة دبي للاراضي و يتم تحويلك لبوابة الدفع الالكتروني.",
	},
	payment_details: {
		en: "Payment Details",
		ar: "بيانات الدفع",
	},
	pay_with: {
		en: "Pay with",
		ar: "ادفع مع",
	},
	noqodi: {
		en: "Noqodi",
		ar: "نقودي",
	},
	invoice_details: {
		en: "Invoice Details",
		ar: "بيانات الفاتورة"
	},
	unit_profile: {
		en: "Unit Profile",
		ar: "ملف الوحدة",
	},
	management_profile: {
		en: "Management Profile",
		ar: "ملف الشركة",
	},
	owner_committee_details: {
		en: "Owner Committee",
		ar: "لجنة ملاك",
	},
	designation: {
		en: "Designation",
		ar: "الدور",
	},
	property_group: {
		en: "Property Group",
		ar: "مجموعة العقار"
	},
	jop_management_company: {
		en: "JOP Management Company",
		ar: "شركة إدارة العقار المشترك"
	},
	owner_committee_member: {
		en: "Owner Committee Member",
		ar: "اعضاء لجنة الملاك",
	},
	back_to_map: {
		en: "Back to Map",
		ar: "الرجوع الى الخريطة",
	},
	unit_details: {
		en: "Unit Details",
		ar: "بيانات الوحدة",
	},
	suite_area: {
		en: "Suite Area",
		ar: "المساحة الداخلية",
	},
	balcony_area: {
		en: "Balcony Area",
		ar: "مساحة البلكونة",
	},
	service_charge_area: {
		en: "Service Charge Area",
		ar: "مساحة رسوم الخدمة",
	},
	mollak_id: {
		en: "Mollak ID",
		ar: "رقم تعريفي في ملاك",
	},
	tenancy_start_date: {
		en: "Tenancy Start Date",
		ar: "تاريخ بدء الإيجار",
	},
	tenancy_end_date: {
		en: "Tenancy End Date",
		ar: "تاريخ نهاية الإيجار",
	},
	service_charge_status: {
		en: "Service Charge Status",
		ar: "حالة رسوم الخدمات",
	},
	outstanding_balance: {
		en: "Outstanding Balance",
		ar: "الرصيد السابق",
	},
	please_select_unit: {
		en: "Please select Unit from the dropdown list",
		ar: "الرجاء اختيار الوحدة من القائمة",
	},
	owners_affairs_manager: {
		en: "Owners Affairs Manager",
		ar: "مدير شؤون الملاك",
	},
	financial_managers: {
		en: "Financial Managers",
		ar: "مدير المرافق"
	},
	facilities_manager: {
		en: "Facilities Manager",
		ar: "مدير المالي",
	},
	compliance_officer: {
		en: "Compliance Officer",
		ar: "ضابط امتثال",
	},
	company_achieved: {
		en: "Company Achieved {0} Medal : Score - {1}",
		ar: "احرزت الشركة الميدالية {0} : العلامة - {1}"
	},
	select_unit: {
		en: "Select unit",
		ar: "اختر الوحدة",
	},
	resident_details: {
		en: "Resident Details",
		ar: "بيانات المستأجر",
	},
	download_statement: {
		en: "Download Statement",
		ar: "تنزيل كشف الحساب",
	},
	mollak_services: {
		en: "Mollak Services",
		ar: "",
	},
	transaction_number: {
		en: "Transaction Number",
		ar: "",
	},
	transaction_date: {
		en: "Transaction Date",
		ar: "",
	},
	transaction_remarks: {
		en: "Transaction Remarks",
		ar: "",
	},
	close_reason: {
		en: "Close Reason",
		ar: "",
	},
	transaction_status: {
		en: "Transaction Status",
		ar: "",
	},
	rvs_status: {
		en: "RVS Status",
		ar: "(RVS) حالة الطلب في",
	},
	rvs_number: {
		en: "RVS Number",
		ar: "(RVS) الرقم المرجعي في ",
	},
};
